import { Controller } from '@hotwired/stimulus'

export default class TextEditorController extends Controller<HTMLElement> {
  connect() {
    document.addEventListener('trix-initialize', this.#reorderToolbarButtons)
    document.addEventListener('trix-change', this.#triggerInputEvent)
  }

  disconnect() {
    document.removeEventListener('trix-initialize', this.#reorderToolbarButtons)
    document.removeEventListener('trix-change', this.#triggerInputEvent)
  }

  #reorderToolbarButtons(event: Event) {
    const nestingLevel = document.querySelector('.trix-button--icon-increase-nesting-level')
    const link = document.querySelector('.trix-button--icon-link')
    const quote = document.querySelector('.trix-button--icon-quote')
    const heading1 = document.querySelector('.trix-button--icon-heading-1')
    const strike = document.querySelector('.trix-button--icon-strike')

    strike.insertAdjacentElement('afterend', heading1)
    nestingLevel.insertAdjacentHTML('afterend', link.outerHTML)
    nestingLevel.insertAdjacentHTML('afterend', quote.outerHTML)

    link.remove()
    quote.remove()
  }

  #triggerInputEvent = ({ target }: Event) => {
    this.dispatch('input', { prefix: '', target: target as Element })
  };
}
